//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Elbow_HSS_score",
  data() {
    return {
      form: {
        pain: "",
        functionA: "",
        functionB: "",
        active:"",
        musclePower:"",
        flexionDeformity:"",
        instability:"",
        rotateA:'',
        rotateB:''
      },
   
      hasScore: false,
      disabled: false,
      dataList1: [
        {
          value: "30",
          name: "从不疼痛",
        },
        {
          value: "15",
          name: " 弯曲时不疼",
        },
        {
          value: "10",
          name: "弯曲时稍疼",
        },
        {
          value: "5",
          name: "弯曲时中度疼痛",
        },
        {
          value: "0",
          name: "弯曲时严重疼痛",
        },
        {
          value: "15",
          name: "休息时不疼",
        },
        {
          value: "10",
          name: "休息时稍疼",
        },
        {
          value: "5",
          name: "休息时中度疼痛",
        },
        {
          value: "0",
          name: "休息时严重疼痛",
        },
      ],
      dataList2: [
        {
          value: "8",
          name: "弯曲活动30min",
        },
        {
          value: "6",
          name: "弯曲活动15min",
        },
        {
          value: "4",
          name: "弯曲活动5min",
        },
        {
          value: "0",
          name: "不能用肘",
        }
      ],
      dataList: [
        {
          value: "12",
          name: "肘可任意活动",
        },
        {
          value: "10",
          name: "仅可娱乐活动",
        },
        {
          value: "8",
          name: "仅限家务活动和工作",
        },
        {
          value: "6",
          name: "可独立自我料理",
        },
        {
          value: "0",
          name: "残废",
        }
      ],
      dataList3: [
        {
          value: "10",
          name: "可提5磅重物（2.3kg）屈90°",
        },
        {
          value: "8",
          name: "可提2磅重物（0.9kg）屈90°",
        },
        {
          value: "5",
          name: "可抗重力屈曲",
        },
        {
          value: "0",
          name: "不能屈曲",
        }
        
      ],
      dataList4: [
        {
          value: "6",
          name: "少于15°",
        },
        {
          value: "4",
          name: "5°~45°",
        },
        {
          value: "2",
          name: "45°~90°",
        },
        {
          value: "0",
          name: "痉挛超过90°",
        }
      ],
      dataList5: [
        {
          value: "6",
          name: "少于15°（全135°中）",
        },
        {
          value: "4",
          name: "少于125°",
        },
        {
          value: "2",
          name: "少于100°",
        },
        {
          value: "0",
          name: "少于80°",
        }
      ],
      dataList6: [
        {
          value: "4",
          name: "＞60°",
        },
        {
          value: "3",
          name: "30°~60°（含60°）",
        },
        {
          value: "2",
          name: "15°~30°（含30°）",
        },
        {
          value: "0",
          name: "＜0°",
        }
      ],
      dataList7: [
        {
          value: "4",
          name: "＞60°",
        },
        {
          value: "3",
          name: "45°~60°（含60°）",
        },
        {
          value: "2",
          name: "5°~45°（含45°）",
        },
        {
          value: "0",
          name: "＜0°",
        }
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
        if(form[key] && form[key]!='active') {
          result += Number(form[key])
        }else {
          result +=Math.floor(Number(form[key]) / 7)
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Elbow_HSS_score.vue